import { baseUrl } from 'infra/config/aws-env'
import { RolesService } from 'infra/services/roles-service'
import { makeAxiosHttpClient } from '../http/axios-http-client-factory'

export const makeRolesService = (): RolesService => new RolesService(baseUrl, makeAxiosHttpClient())
